/**
 * Blockchain chain configuration data.
 *
 * This module exports chain-specific configuration including:
 * - implementations: NFT factory implementations for different chain groups
 * - chainData: Detailed network parameters for each supported blockchain
 *
 * The data includes RPC endpoints, contract addresses, chain IDs,
 * token symbols, and visibility flags (hidden).
 *
 * @module chains
 * @category Configuration
 */

// chain data for frontend

// nw 1 old am: 0x9191F9f9dB2d8AbCd5C787F9956852e65fBF83e5

/**
 * Array of NFT factory contract implementation addresses.
 *
 * Indexed by chain group (testnet, mainnet networks).
 * Each entry contains an array of implementation objects with:
 * - setName: Display name for the implementation
 * - nftFactory: NFT factory contract address
 * - rManager: Reward manager contract address
 * - config: Configuration contract address
 *
 * @type {Array<Array<{setName: string, nftFactory: string, rManager: string, config: string}>>}
 */
export const implementations = [,
    [// testnet
        {
            setName: "Default",
            nftFactory: "0x1234",
            rManager: "0x1234",
            config: "0xaaaaaa"
        }
    ],
    [//songbird
        {
            name: "Songbird Default",
            nftFactory: "0xE8Ea4752D863c6e041731D0b8bb5c0692E1a65d7",
            rManager: "0x679F36172cc0Bcfe6C56b5B488B8D8e53e92C268",
            config: "0x6a2543127cE354B7985ac01Ed01f97F075aA8A63"
        },
        {
            name: "Songbird Unlimited Mints",
            nftFactory: "0x123",
            rManager: "0xabababab",
            config: "0x2345"
        }
    ],
    [//coston
        [{}]
    ],
    [// binance smart chain
        [{}],
    ],
    [// flare
        [{}],
    ],
    [// XDC
        [{}],
    ],
    [// Coston 2
        [{}],
    ],
]
/**
 * Array of chain configuration objects.
 *
 * Each object contains:
 * - rpc: RPC endpoint URL
 * - chainId: Chain identifier (string)
 * - tokName: Native token symbol
 * - network: Network name (e.g., "Flare", "XinFin")
 * - chainName: Display name for the chain
 * - nftDeployer: NFT deployer contract address (optional)
 * - aManager: Auction manager contract address (optional)
 * - bgti: BGTI contract address (optional)
 * - MultiCall: Multicall contract address (optional)
 * - PriceConverter: Price converter contract address (optional)
 * - WNat: Wrapped native token address (optional)
 * - erc20Factory: ERC20 factory contract address (optional)
 * - exp: Block explorer URL (optional)
 * - hidden: Whether the chain is hidden from UI (boolean)
 *
 * Index 0 is reserved/empty.
 *
 * @type {Array<object>}
 */
// "0x5d70A98083Da26fd5E0932c4afB4456d02184BB4",
import chainDataJson from './chainData.json';

// Re-export as both a named and default binding so existing consumers that do
// `import { chainData } from './chains.js'` keep working after the data moved
// to JSON (the sitemap reads chainData.json directly).
export const chainData = chainDataJson;
export default chainData;

// 0x9191F9f9dB2d8AbCd5C787F9956852e65fBF83e5
// 0x93AA59D3104A9Ec312c17eA4F122dBdfAF7d1286
